/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides

const myCustomLightTheme = {
  dark: false,
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    red: '#e21833',
    botMessages: '#E9EDF1',
    userMessages: '#406770',
    botText: '#000000',
    userText: '#FFFFFF',
    header: '#FFFFFF',
    icons: '#636363',
    citationNumbers: '#0000FF',
    greetingText: '#616161'
  }
}

const myCustomDarkTheme = {
  dark: true,
  colors: {
    background: '#121212',
    surface: '#121212',
    red: '#e21833',
    botMessages: '#404040',
    userMessages: '#406770',
    botText: '#E0E0E0',
    userText: '#FFFFFF',
    header: '#FFFFFF',
    icons: '#E0E0E0',
    citationNumbers: '#93c5fd',
    greetingText: '#E0E0E0'
  }
}

export default createVuetify({
  theme: {
    defaultTheme: 'myCustomLightTheme',
    themes: {
      myCustomLightTheme,
      myCustomDarkTheme
    },
  },
})
